<div #chart class="absolute top-0 h-full w-full"></div>
<div #selection class="h-full w-full"></div>
